module.exports = __webpack_public_path__ + "static/media/positionAuthStateImportTemp.1a511190.xlsx";